import Joi from "joi";
import Form from "../../common/form";
import PropTypes from "prop-types";
import toast from "react-hot-toast";

import Button from "../../themed/button";
import Conditional from "../../common/conditional";

interface InfraredEquipment {
    equipmentName: string;
    modal: string;
    serialNumber: string;
    temperature: number;
    calibrationDueDate: Date;
    accuracy: number;
}

class InfraredEquipmentForm extends Form {
    state = { 
        data: {
			equipmentName: '',
            modal: '',
            serialNumber: '',
            calibrationDueDate: new Date(),
            temperature: '',
            accuracy: '',
		},
		errors: {},
		loading: false,
		progress: 0
    };

    schema = {
        equipmentName: Joi.string().required().label('Equipment Name'),
        modal: Joi.string().required().label('Modal'),
        serialNumber: Joi.string().required().label('Serial Number'),
        temperature: Joi.number().required().label('Temperature (C)'),
        calibrationDueDate: Joi.date().greater('now').required().label('Calibration Due Date'),
        accuracy: Joi.number().required().label('Accuracy (+/-)'),
    };

    static propTypes = {
        initialInfraredData: PropTypes.object,
        onDeleteItem: PropTypes.func,
        onSave: PropTypes.func,
    };
    
    componentDidMount(): void {
        if (this.props.initialInfraredData) {
            this.setState({ data: this.props.initialInfraredData });
        }
    }

    doSubmit = () => {
        this.props.onSave(this.state.data);

        if (!this.props.initialInfraredData) {
            this.setState({
                data: {
                    equipmentName: '',
                    modal: '',
                    serialNumber: '',
                    temperature: '',
                    calibrationDueDate: new Date(),
                    accuracy: '',
                },
            })
        }

        toast.success('Saved successfully!');
    };

    render() { 
        return ( 
            <form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Equipment Details</h3>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'equipmentName',
                                label: 'Equipment Name',
                                placeholder: 'Enter Equipment Name',
                            })}
                        </div>
                        
                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'modal',
                                label: 'Modal',
                                placeholder: 'Enter Equipment Modal',
                            })}
                        </div>

                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'serialNumber',
                                label: 'Serial Number',
                                placeholder: 'Enter Equipment Serial Number',
                            })}
                        </div>
                    </div>
                    
                    <div className="divider my-4"></div>

                    <div className="row">
                        <div className="col">
                            {this.renderDatePicker({
								name: 'calibrationDueDate',
								label: 'Calibration Due Date',
								placeholderText: 'Select Calibration Due Date',
								minDate: new Date(),
							})}
                        </div>

                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'temperature',
                                label: 'Temperature',
                                placeholder: 'Enter Temperature (C)',
                            })}
                        </div>
                        
                        <div className="col">
                            {this.renderInput({
                                type: 'number',
                                name: 'accuracy',
                                label: 'Accuracy',
                                placeholder: 'Enter Accuracy (+/-)',
                            })}
                        </div>
                    </div>
                </div>

                <div className="divider my-4"></div>

                <div className="d-flex justify-content-end">
                    <Conditional isVisible={!!this.props.onDeleteItem}>
                        <div className="me-3">
                            <Button
                                onClick={this.props.onDeleteItem} 
                                icon="trash"
                                type="button"
                                label="Delete" 
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>
                    </Conditional>

				    {this.renderButton('Save')}
                </div>
			</form>
        );
    }
}

export type { InfraredEquipment };
export default InfraredEquipmentForm;